import axios from 'axios';
import { BaseUrls } from './url';


const httpClient = axios.create({ baseURL: BaseUrls.holidayUrl });
httpClient.defaults.headers.common['Accept'] = 'application/json';
httpClient.defaults.headers.common['Content-Type'] = 'application/json';
//httpClient.defaults.headers.common['Authorization'] = USER_TOKEN;

export const getHoliday = async (id) => {
    const url = BaseUrls.holidayUrl.concat("?id=").concat(id);
    return httpClient.get(url)
        .then(response => response.data)
        .catch(error => error.data);
};